import React from "react";
import {
  Alert,
  Badge,
  Button,
  Container,
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { logout } from "../academyStore/slices/AuthSlice";
import Logo from "../assets/logo.png";

const NavBar = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLogged = useSelector((state) => state.user.isLoggedIn);
  const logoutHandler = () => {
    dispatch(logout());
    navigate("/");
  };
  return (
    <Navbar expand="lg" className="fixed-top sticky-top bg-white shadow-sm">
      <Container fluid className="nav-menu">
        <Navbar.Brand>
          <img src={Logo} alt="Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="nav-menu" />
        <Navbar.Offcanvas
          id="nav-menu"
          aria-labelledby="navbar"
          placement="start"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>VK Profiles</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="ms-auto fw-bold navbar-menu">
              <LinkContainer to={"/"}>
                <Nav.Link>Home</Nav.Link>
              </LinkContainer>
              <LinkContainer to={"/courses"}>
                <Nav.Link>Courses</Nav.Link>
              </LinkContainer>
              <LinkContainer to={"/subscription"}>
                <Nav.Link>Subscription</Nav.Link>
              </LinkContainer>
              <LinkContainer to={"/interviews"}>
                <Nav.Link>Interview QA</Nav.Link>
              </LinkContainer>
              <LinkContainer to={"/quiz"}>
                <Nav.Link>Daily Quiz</Nav.Link>
              </LinkContainer>
              <LinkContainer to={"/dailyproblems"}>
                <Nav.Link>Daily Problems</Nav.Link>
              </LinkContainer>
              <LinkContainer to={"/roadmaps"}>
                <Nav.Link>Roadmap</Nav.Link>
              </LinkContainer>
              <Nav.Link
                onClick={() =>
                  window.open("https://jobs.htacademy.in/", "_blank")
                }
                target="_blank"
              >
                Jobs
              </Nav.Link>
              {!isLogged && (
                <LinkContainer to={"/login"}>
                  <Nav.Link href="#">
                    <Button variant="danger" size="sm" className="px-3">
                      <i className="fas fa-sign-in-alt"></i>&nbsp; Sign In
                    </Button>
                  </Nav.Link>
                </LinkContainer>
              )}
              {!isLogged && (
                <LinkContainer to={"/signup"}>
                  <Nav.Link>
                    <Button variant="warning" size="sm" className="px-3">
                      <i className="fas fa-user-alt"></i>&nbsp; Sign Up
                    </Button>
                  </Nav.Link>
                </LinkContainer>
              )}
              {isLogged && (
                <Nav.Link className="profile d-flext justify-content-start align-items-start">
                  <span className="d-flex align-items-center">
                    <i className="fas fa-user-circle fs-1"></i> &nbsp;
                    <span>Profile</span>
                  </span>
                  <Alert variant="secondary" className="drop">
                    <LinkContainer to={"/dashboard"}>
                      <Nav.Link className="py-1">My Account</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to={"/mycourses"}>
                      <Nav.Link className="py-1">My Courses</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to={"/mywallet"}>
                      <Nav.Link className="py-1">My Wallet</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to={"/mypayments"}>
                      <Nav.Link>My Payments</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to={"/myassignments"}>
                      <Nav.Link className="py-1">My Assignments</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to={"/myresume"}>
                      <Nav.Link className="py-1">My Resume</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to={"/interviewans"}>
                      <Nav.Link className="py-1">Interview Q&A</Nav.Link>
                    </LinkContainer>
                    <LinkContainer to={"/problems"}>
                      <Nav.Link className="py-1">Problems</Nav.Link>
                    </LinkContainer>
                    <hr className="my-1" />
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="px-3 w-100 my-2"
                      onClick={logoutHandler}
                    >
                      <i className="fas fa-sign-out-alt"></i>&nbsp; Logout
                    </Button>
                  </Alert>
                </Nav.Link>
              )}
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};

export default NavBar;
